import { gql } from 'graphql-tag';

export const CREATE_PROPOSAL_ON_SUBMISSION_APPROVAL = gql`
  mutation CreateProposalOnSubmissionApproval($input: CreateLenderProposalInput!) {
    createProposalOnSubmissionApproval(input: $input) {
      success
      error
      entity {
        id
      }
    }
  }
`;
